(function () {
  document.querySelectorAll('[data-product-info]').forEach(function (root) {
    var sectionId = root.getAttribute('data-section-id');
    var variantsScript = root.querySelector('#ProductVariants-' + sectionId);
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

    var form = root.querySelector('[data-product-form]');
    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-product-price]');
    var inventoryEl = root.querySelector('[data-inventory-status]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var addButtonText = root.querySelector('[data-add-to-cart-text]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var gallery = document.getElementById('ProductGallery-' + sectionId);
    var optionFieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

    /* ---------- Quantity stepper ---------- */
    var decreaseBtn = root.querySelector('[data-quantity-decrease]');
    var increaseBtn = root.querySelector('[data-quantity-increase]');
    if (decreaseBtn && quantityInput) {
      decreaseBtn.addEventListener('click', function () {
        var value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
        quantityInput.value = value;
      });
    }
    if (increaseBtn && quantityInput) {
      increaseBtn.addEventListener('click', function () {
        quantityInput.value = (parseInt(quantityInput.value, 10) || 1) + 1;
      });
    }

    /* ---------- Variant selection ---------- */
    function getSelectedOptions() {
      return optionFieldsets
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (fieldset) {
          var checked = fieldset.querySelector('[data-option-value]:checked');
          return checked ? checked.value : null;
        });
    }

    function findVariant(options) {
      return variants.filter(function (variant) {
        return variant.options.every(function (value, i) { return value === options[i]; });
      })[0] || null;
    }

    function updateAvailability(selected) {
      optionFieldsets.forEach(function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-option-index'), 10);
        fieldset.querySelectorAll('[data-option-value]').forEach(function (radio) {
          var candidate = selected.slice();
          candidate[index] = radio.value;
          var match = findVariant(candidate);
          radio.disabled = !match;
          if (match) radio.classList.toggle('is-unavailable', !match.available);
        });
      });
    }

    function renderPrice(variant) {
      if (!priceEl || !variant) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var format = window.theme.moneyFormat;
      if (onSale) {
        priceEl.classList.add('price--on-sale');
        priceEl.innerHTML =
          '<s class="price__compare">' + window.theme.formatMoney(variant.compare_at_price, format) + '</s>' +
          '<span class="price__sale">' + window.theme.formatMoney(variant.price, format) + '</span>';
      } else {
        priceEl.classList.remove('price--on-sale');
        priceEl.innerHTML = '<span class="price__regular">' + window.theme.formatMoney(variant.price, format) + '</span>';
      }
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        if (addButton) addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = window.theme.strings.unavailable || 'Unavailable';
        if (inventoryEl) inventoryEl.textContent = '';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      renderPrice(variant);

      if (addButton) addButton.disabled = !variant.available;
      if (addButtonText) {
        addButtonText.textContent = variant.available
          ? (addButtonText.getAttribute('data-label-available') || addButtonText.textContent)
          : window.theme.strings.soldOut;
      }

      if (gallery && variant.featured_media) {
        gallery.dispatchEvent(new CustomEvent('gallery:select-media', {
          detail: { mediaId: String(variant.featured_media.id) }
        }));
      }
    }

    if (addButtonText && !addButtonText.getAttribute('data-label-available')) {
      addButtonText.setAttribute('data-label-available', addButtonText.textContent);
    }

    optionFieldsets.forEach(function (fieldset) {
      fieldset.addEventListener('change', function () {
        var selected = getSelectedOptions();
        updateAvailability(selected);
        updateForVariant(findVariant(selected));
      });
    });

    if (optionFieldsets.length) {
      updateAvailability(getSelectedOptions());
    }

    /* ---------- Add to cart (AJAX) ---------- */
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (addButton) addButton.disabled = true;

        fetch(window.theme.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: variantIdInput ? variantIdInput.value : undefined,
            quantity: quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1,
            sections: 'cart-drawer'
          })
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            if (data.status) {
              throw new Error(data.description || 'Could not add to cart');
            }

            var cartType = window.theme.settings.cartType;
            if (cartType === 'drawer') {
              var newDrawer = window.theme.replaceSectionFragment(
                'CartDrawer',
                data.sections && data.sections['cart-drawer']
              );
              if (newDrawer) newDrawer.showModal();
            } else if (cartType === 'page') {
              window.location.href = window.theme.routes.cartUrl;
              return null;
            } else {
              announce(window.theme.strings.addedToCart);
            }

            return fetch(window.theme.routes.cartUrl + '.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(function (error) {
            announce(error.message, true);
          })
          .finally(function () {
            if (addButton) addButton.disabled = false;
          });
      });
    }

    function announce(message, isError) {
      var live = document.getElementById('CartStatusAnnouncer');
      if (!live) {
        live = document.createElement('div');
        live.id = 'CartStatusAnnouncer';
        live.setAttribute('role', 'status');
        live.className = 'visually-hidden';
        document.body.appendChild(live);
      }
      live.textContent = message;
      if (isError) window.console.error(message);
    }

    /* ---------- Sticky mobile add-to-cart bar ---------- */
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var buyButtonsAnchor = root.querySelector('[data-buy-buttons-observer]');
    if (stickyBar && buyButtonsAnchor) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.hidden = !scrolledPast;
      }, { threshold: 0 }).observe(buyButtonsAnchor);

      var stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
      if (stickyButton && addButton) {
        stickyButton.addEventListener('click', function () { addButton.click(); });
      }
    }
  });
})();
